/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import { ErrorHandler } from '@playbookux/playbook-web-core';
import { TEST_SESSION_BOOKING_STATUS } from '../../../../../core/constants/test-session-status';
// graphql
import {
  updateTestSession, UPDATE_TEST_SESSION_BOOKING_STATUS, GET_TEST_SESSIONS, LIMIT,
} from '../graphql';

// styles
import {
  Modal, ModalHeader, ModalFooter, ContainerCheckbox, CheckboxContent, Checkbox, ModalButton,
  Container, Loader,
} from '../styles';

function EditStatusModal({
  handleCloseModal,
  open,
  testSession,
  projectId,
  refetch,
}) {
  const [selectedStatus, setSelectedStatus] = useState(testSession.bookingStatus);

  const [updateTestSessionStatusMutation, { loading, error }] = useMutation(UPDATE_TEST_SESSION_BOOKING_STATUS, {
    update: updateTestSession(projectId),
    onCompleted: refetch,
    refetchQueries: [
      {
        query: GET_TEST_SESSIONS,
        variables: {
          projectId,
          limit: LIMIT,
          removed: false,
        },
      },
    ],
  });

  const getCheckBoxProps = (status) => ({
    checked: selectedStatus === status.value,
    onChange: () => setSelectedStatus(status.value),
    value: status.value,
    radio: true,
    label: status.label,
  });

  const handleUpdateTestSessionStatus = (status) => {
    if (testSession && status) {
      updateTestSessionStatusMutation({
        variables: {
          id: testSession.id,
          bookingStatus: status,
        },
      });
    }
    handleCloseModal();
  };

  if (loading) {
    return (
      <Container>
        <Loader size="small" data-loader="edit-status-loader" />
      </Container>
    );
  }

  if (error) {
    return (
      <ErrorHandler
        error={error}
        defaultMessage="Error while retrieving the testers."
      />
    );
  }

  return (
    <Modal open={open} onClose={handleCloseModal} size="tiny">
      <ModalHeader>
        {testSession.firstName}
        {' '}
        Status:
      </ModalHeader>

      <ContainerCheckbox>

        <CheckboxContent>
          <Checkbox
            {...getCheckBoxProps(TEST_SESSION_BOOKING_STATUS.confirmed)}
          />
        </CheckboxContent>

        <CheckboxContent>
          <Checkbox
            {...getCheckBoxProps(TEST_SESSION_BOOKING_STATUS.didNotShow)}
          />

        </CheckboxContent>

        <CheckboxContent>
          <Checkbox
            {...getCheckBoxProps(TEST_SESSION_BOOKING_STATUS.researcherDidNotSHow)}
          />
        </CheckboxContent>
        <CheckboxContent>
          <Checkbox
            {...getCheckBoxProps(TEST_SESSION_BOOKING_STATUS.interviewCompleted)}
          />
        </CheckboxContent>

      </ContainerCheckbox>

      <ModalFooter>
        <p style={{ visibility: 'hidden' }} />
        <ModalButton onClick={() => handleUpdateTestSessionStatus(selectedStatus)}>
          Save
        </ModalButton>
      </ModalFooter>
    </Modal>
  );
}

EditStatusModal.propTypes = {
  handleCloseModal: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  testSession: PropTypes.object.isRequired,
  projectId: PropTypes.string.isRequired,
  refetch: PropTypes.func.isRequired,
};

export default EditStatusModal;
